import { IntlShape } from 'react-intl';
import I18nTexts from './I18nTexts';
import { PrimitiveType } from './PrimitiveType';
import { EnvName } from '../../configuration/configuration';

export default function translateText(
    intl: IntlShape,
    textKey: keyof I18nTexts,
    paramsObj?: Record<string, PrimitiveType>
) {
    try {
        return intl.formatMessage({ id: textKey }, paramsObj);
    } catch {
        // Do not log in test or production
        if (process.env.NODE_ENV === EnvName.DEV) {
            console.warn(`Missing translation key.`);
        }
        return textKey;
    }
}
